import { ServiceMaker, methods, services } from "../services";

export const createAd = payload =>
  ServiceMaker(`/create`, methods.PUT, services.advertisement, payload);

export const updateAd = (payload) =>
  ServiceMaker(`/update`, methods.PUT, services.advertisement, payload);

export const fetchAdByTenant = payload =>
  ServiceMaker(`/get-ad-v2`, methods.POST, services.advertisement, payload);

export const deleteAd = Id =>
  ServiceMaker(`/delete/${Id}`, methods.DELETE, services.advertisement);

export const switchBannerStatus = (payload) =>
  ServiceMaker(`/update-status/${payload.id}`, methods.PATCH, services.advertisement, payload.switchvalue);

  export const fetchPlacementList = payload =>
  ServiceMaker(`/ad-location/list`, methods.GET, services.advertisement, payload);

  export const adDetails = id =>
  ServiceMaker(`/get-ad/${id}`, methods.GET, services.advertisement);

  export const fetchEntitiesList = (payload) =>
  ServiceMaker(
    `/batch-processor/entities/list?label=${payload.label}`,
    methods.GET,
    services.master
  );